export default function Home() {
  return (
    <div className="min-h-screen">
      {/* 页面 Schema 结构化数据 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '17c.c',
            url: 'https://17c.c',
            description: '17c.c 是您值得信赖的首选平台，汇聚海量优质内容与资源。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://17c.c/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* Hero Section */}
      <HeroSection />

      {/* Category Navigation */}
      <CategorySection />

      {/* Featured Articles */}
      <FeaturedArticlesSection />

      {/* Stats Section */}
      <StatsSection />

      {/* FAQ Section */}
      <FAQSection />

      {/* CTA Section */}
      <CTASection />
    </div>
  );
}

import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getFeaturedArticles } from '@/mocks/articles';
import { faqList } from '@/mocks/faq';
import ArticleCard from '@/components/feature/ArticleCard';

function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20digital%20content%20platform%20hero%20background%20with%20abstract%20geometric%20shapes%20in%20warm%20cream%2C%20coral%20and%20soft%20orange%20tones%2C%20floating%20cards%20and%20content%20elements%2C%20clean%20elegant%20design%2C%20soft%20gradients%2C%20no%20text%2C%20digital%20platform%20theme%20with%20warm%20atmosphere&width=1800&height=900&seq=hero-17cc&orientation=landscape"
        alt="17c.c 平台背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 font-heading leading-tight">
            探索全新体验，发现无限可能
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-200/90 max-w-2xl mx-auto leading-relaxed">
            17c.c 是您值得信赖的首选平台，汇聚海量优质内容与资源。立即访问 17c.c，享受极致流畅的使用体验。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/zixun"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即探索
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
            探索内容分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大内容板块，精准匹配您的兴趣与需求
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-xl`} />
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">
                {cat.count} 篇
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedArticlesSection() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              编辑团队为您精心挑选的优质内容
            </p>
          </div>
          <Link
            to="/category/zixun"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const stats = [
    { value: '500+', label: '精选文章', icon: 'ri-article-line' },
    { value: '6', label: '内容分类', icon: 'ri-folder-line' },
    { value: '50万+', label: '月活跃用户', icon: 'ri-user-line' },
    { value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line' },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {stats.map((stat, i) => (
          <div key={i} className="text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-background-50/20 mb-4">
              <i className={`${stat.icon} text-xl text-background-50`} />
            </div>
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
              {stat.value}
            </div>
            <div className="mt-1 text-sm text-background-200">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            关于 17c.c 的常见疑问解答
          </p>
        </div>

        {/* FAQPage Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqList.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />

        <div className="space-y-3">
          {faqList.map((faq, i) => (
            <details
              key={i}
              className="group rounded-lg border border-background-200/70 bg-background-50 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-800 hover:text-primary-500 transition-colors list-none marker:content-none">
                <span>{faq.question}</span>
                <i className="ri-add-line text-foreground-400 group-open:hidden text-sm" />
                <i className="ri-subtract-line text-foreground-400 hidden group-open:block text-sm" />
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20abstract%20background%20with%20soft%20overlapping%20shapes%20in%20coral%20and%20cream%20tones%2C%20gentle%20gradients%2C%20clean%20minimalist%20design%2C%20digital%20content%20platform%20theme%2C%20no%20text%2C%20smooth%20organic%20shapes&width=1800&height=600&seq=cta-17cc&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-900/60" />
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-bold text-background-50 font-heading">
          准备好开始探索了吗？
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed">
          立即访问 17c.c，加入数百万用户的行列，发现更多精彩功能与专属服务。
        </p>
        <Link
          to="/category/jiaocheng"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          免费开始使用
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}